



















import Vue from 'vue';
import { IMenuItem } from '@/common/interfaces/header.interface';
import DesktopDropdownColumnEntry from './DesktopDropdownColumnEntry.vue';

export default Vue.extend({
  name: `Dropdown`,
  components: { DesktopDropdownColumnEntry },
  props: {
    entries: {
      required: true,
      type: Array as () => IMenuItem[][],
    },
    keyboardNavigation: {
      required: true,
      type: Object as () => { menuToShow: string | null; show: boolean },
    },
    title: {
      required: true,
      type: String,
    },
  },
});
